import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OrderDto } from '@up/data';
import { ENV_OPTIONS } from '@up/shared/injection-tokens';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderReceiptService {
  readonly API_KEY = 'order-receipt';
  readonly API_URL = `${this.environmentOptions.apiUrl}/${this.API_KEY}`;

  constructor(
    @Inject(ENV_OPTIONS) private environmentOptions: any,
    private http: HttpClient
  ) {}

  public getByOrderLinkAndMerchantLink(
    orderLink: string,
    merchantLink: string
  ): Observable<OrderDto> {
    const params = new HttpParams()
        .set('orderLink', orderLink)
        .set('merchantLink', merchantLink);

    return this.http
      .get<OrderDto>(this.API_URL +`/getByOrderLinkAndMerchantLink`, { params })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

  public getWalletUrls(orderId: number): Observable<{ googleWalletLink: string, appleWalletLink: string }> {
    return this.http
        .get<{ googleWalletLink: string, appleWalletLink: string }>(
            `${this.API_URL}/walletUrls/${orderId}`
        )
        .pipe(
            catchError(this.handleError)
        );
  }

  getCartByIdAndMerchantLink(cartId: string, merchantLink: string): Observable<any> {
    const params = new HttpParams()
        .set('cartId', cartId)
        .set('merchantLink', merchantLink);

    return this.http.get(this.API_URL + `/getByCartIdAndMerchantLink`, { params })
        .pipe(
            map((data) => data),
            catchError(this.handleError)
        );
  }

  private handleError(res: HttpErrorResponse | any) {
    console.error(res.error || res.body.error);
    return observableThrowError(res.error || 'Server error');
  }
}
